import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Детски калъфки за възглавници от ранфорс – 100% памук | GoToBed',
  description:
    'Детски калъфки за възглавници от ранфорс, 100% памук. Размери 30/40, 35/53, 40/60, 50/70. Изработка по поръчка. Поръчайте от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Детски калъфки за възглавници от ранфорс
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Детски калъфки за възглавници от ранфорс – 100% памук и разнообразие от размери
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Детските калъфки за възглавници от ранфорс са изработени от 100% памук и са практичен
          избор за бебешко и детско спално бельо. Материята е дишаща, здрава и приятна на допир,
          което я прави подходяща за чувствителната бебешка и детска кожа.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Калъфките се изработват по поръчка и се предлагат в разнообразие от размери, сред които
          популярните 30/40, 35/53, 40/60 и 50/70. Можете да избирате между едноцветни и шарени (с
          принт) десени, подходящи за различни комплекти детско спално бельо.
        </Typography>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyDetskiKalufkiRanfors />;
}

function SeoBodyDetskiKalufkiRanfors() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Детски калъфки за възглавници от ранфорс – 100% памук */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Детски калъфки за възглавници от ранфорс – 100% памук
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Калъфките от ранфорс са практично решение за родители, които търсят удобно, безопасно и
        дълготрайно детско спално бельо. Ранфорсът е висококачествен 100% памучен плат, който се
        отличава с добра издръжливост, дишаемост и комфорт при сън.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Детската кожа е по-чувствителна, затова изборът на естествени материи е особено важен.
        Калъфките от ранфорс са меки, дишащи и приятни на допир, което осигурява комфортен сън и
        намалява риска от раздразнения по кожата.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Всички наши детски калъфки от ранфорс се изработват от платове със сертификат OEKO-TEX
        Standard 100, който гарантира, че текстилът е безопасен и не съдържа вредни вещества.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        Ако искате да разгледате всички модели, можете да посетите и
      </Typography>
      <Box sx={{ mb: 2, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/kategorii/detsko-spalno-belio/detski-kalufki/2/8"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          всички детски калъфки
        </Typography>
      </Box>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        За да създадете удобен комплект детско спално бельо от същата материя, можете да комбинирате
        калъфките с
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-plikove/2/10/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски пликове ранфорс
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-charshafi/2/7/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски чаршафи ранфорс
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-charshafi-s-lastik/2/9/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски чаршафи с ластик ранфорс
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Какво представлява платът ранфорс? */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Какво представлява платът ранфорс?
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ранфорсът е плътна памучна тъкан, изработена от 100% естествени влакна. Той е много
          популярен при спалното бельо, защото съчетава комфорт, здравина и дълготрайност.
        </Typography>
        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Основни предимства на ранфорса
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '&#10004; 100% памук',
            '&#10004; дишаща и приятна на допир материя',
            '&#10004; устойчивост при често пране',
            '&#10004; комфорт през всички сезони',
            '&#10004; подходящ за бебешко и детско спално бельо'
          ].map((item) => (
            <Typography
              key={item}
              variant="body1"
              sx={{ color: 'text.secondary' }}
              dangerouslySetInnerHTML={{ __html: item }}
            />
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Благодарение на тези качества детските калъфки от ранфорс са практичен избор за ежедневна
          употреба и за поддържане на добра хигиена на детското спално бельо.
        </Typography>

        {/* H2: Предимства на нашите детски калъфки от ранфорс */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Предимства на нашите детски калъфки от ранфорс
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '&#10004; изработени от 100% памук ранфорс',
            '&#10004; подходящи за бебешки и детски възглавници',
            '&#10004; голям избор от размери',
            '&#10004; дишащ и комфортен плат',
            '&#10004; платове със сертификат OEKO-TEX Standard 100',
            '&#10004; безопасни за чувствителната детска кожа',
            '&#10004; произведени в България'
          ].map((item) => (
            <Typography
              key={item}
              variant="body1"
              sx={{ color: 'text.secondary' }}
              dangerouslySetInnerHTML={{ __html: item }}
            />
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Калъфките от ранфорс са практично решение за родители, които търсят качествено и безопасно
          детско спално бельо от естествени материи.
        </Typography>

        {/* H2: Размери детски калъфки за бебешки и детски възглавници */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Размери детски калъфки за бебешки и детски възглавници
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Сред най-търсените размери са:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            'калъфка 30/40 (30х40) см за бебешка възглавница',
            'калъфка 35/53 (35х53) см за детска възглавница',
            'калъфка 40/50 (40х50) см за детска възглавница',
            'калъфка 40/60 (40х60) см за детска възглавница',
            'калъфка 50/70 (50х70) см за стандартна възглавница',
            'калъфка 70/70 (70х70) см за квадратна възглавница'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Благодарение на богатото разнообразие от размери можете лесно да намерите подходяща
          калъфка за бебешка възглавница или калъфка за детска възглавница, която да пасне точно на
          възглавницата.
        </Typography>

        {/* H2: Срок за изработка */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Срок за изработка
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Всички калъфки се изработват индивидуално след направена поръчка, според избрания размер.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Срокът за изработка е между 3 и 10 работни дни, като в повечето случаи поръчките са готови
          в рамките на 4–7 работни дни.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за детски калъфки от ранфорс
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер калъфка за детска възглавница?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            За да изберете подходяща калъфка за детска възглавница, измерете ширината и дължината на
            възглавницата и изберете калъфка със същия размер. В нашия магазин ще откриете калъфки
            за бебешки и детски възглавници в много различни размери, което позволява лесно да
            намерите подходящия вариант.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящ ли е платът ранфорс за бебешко спално бельо?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Ранфорсът е 100% памучен плат, който е дишащ, мек и приятен на допир. Това го прави
            много подходящ за бебешко и детско спално бельо, защото осигурява комфорт и добра
            циркулация на въздуха.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свиват ли се калъфките от ранфорс след пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Както всички изделия от 100% памук, и калъфките от ранфорс могат да имат естествена
            свиваемост около 4–5% след първите пранета. Това е нормално свойство на памучните
            материи.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са калъфките за различни размери възглавници?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Предлагаме детски калъфки за възглавници в много различни размери, което позволява
            да намерите подходяща калъфка както за бебешки възглавници, така и за по-големи детски
            възглавници.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват калъфките?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички детски калъфки от ранфорс се изработват в България, специално за всяка поръчка и
            според избрания размер.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
